import { environment } from "@environment";
import { Component, Inject, Injector } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material/bottom-sheet";

import { GtmService } from "@app/core/services/analytics/gtm.service";
import { DeviceService } from "@app/core/services/util/device.service";
import { UtilityService } from "@app/core/services/util/utility.service";

@Component({
    selector: "app-agent-offer",
    templateUrl: "./agent-offer.component.html",
    styleUrls: ["./agent-offer.component.scss"],
    standalone: true
})
export class AgentOfferComponent {
    DEPLOY_URL: string;
    offerDetails: any;
    isMobile: boolean;
    dialogRef: MatDialogRef<any, any>;

    constructor(
        @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
        public bottomSheetRef: MatBottomSheetRef<AgentOfferComponent>,
        private injector: Injector,
        private gtmService: GtmService,
        private deviceService: DeviceService,
        private utilityService: UtilityService
    ) {

        this.DEPLOY_URL = environment.DEPLOY_URL;
        this.isMobile = this.deviceService.isMobile();

        if (!this.isMobile) {
            this.dialogRef = this.injector.get(MatDialogRef, null);
            this.data = this.injector.get(MAT_DIALOG_DATA, null);
        }

        const { offer_details } = this.data;
        this.offerDetails = offer_details;
        this.gtmService.logEvent("web_analytics", {
            event_action: "new_ordering_flow",
            event_label: "Agent Based Offer Screen",
            value1: "Opened"
        });
    }

    copyCode(code: string) {
        this.gtmService.logWebAnalyticsEvent("new_ordering_flow", "Agent Based Offer Screen", "Copy Code: " + code);
        this.utilityService.copyCode(code);
    }

    close() {
        if (!this.isMobile) {
            this.dialogRef.close();
        } else {
            this.bottomSheetRef.dismiss();
        }
    }
}
